import {
    SupervisorGroupAction,
    SupervisorGroupActionType,
} from '../actions/SupervisorGroupActions';
import { SupervisorGroup } from '../types';

const supervisorGroupReducer = (
    state: Array<SupervisorGroup> = [],
    action: SupervisorGroupAction
) => {
    switch (action.type) {
        case SupervisorGroupActionType.GET_ALL_SUPERVISOR_GROUPS:
        case SupervisorGroupActionType.CLEAR_SUPERVISOR_GROUPS:
            return action.payload;
        case SupervisorGroupActionType.CREATE_SUPERVISOR_GROUP:
            return [...state, action.payload];
        case SupervisorGroupActionType.GET_SUPERVISOR_GROUP:
        case SupervisorGroupActionType.DELETE_SUPERVISOR_GROUPS:
        case SupervisorGroupActionType.MERGE_SUPERVISOR_GROUPS:
        case SupervisorGroupActionType.UPDATE_SUPERVISOR_GROUP:
            return state.map((supervisorGroup: SupervisorGroup) => {
                const newSupervisorGroup = action.payload as SupervisorGroup;
                if (supervisorGroup._id === newSupervisorGroup._id) {
                    return newSupervisorGroup;
                } else {
                    return supervisorGroup;
                }
            });
        default:
            return state;
    }
};

export default supervisorGroupReducer;
